<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">General Ledger Accounts</h4>
                <p class="text-subtitle-1">List of all general ledger accounts</p>
            </v-col>
        </v-row>
        <v-sheet >
            <v-toolbar flat>
                <v-row>
                    <v-col>
                        <v-btn color="primary" class="me-2" @click="dialog = true">
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                        <v-menu offset-y min-width="200" v-if="selected.length > 0">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                >
                                actions
                                <v-icon right>mdi-menu-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item link @click="handleFreezeAccount">
                                    <v-list-item-title>Freeze Account</v-list-item-title>
                                </v-list-item>
                                <v-list-item link @click="handleUnfreezeAccount">
                                    <v-list-item-title>Unfreeze Account</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-divider></v-divider>
            <v-row>
                <v-col>
                    <v-data-table
                        v-model="selected"
                        show-select
                        dense
                        :options.sync="options"
                        :loading="loading"
                        :headers="headers"
                        :server-items-length="count"
                        :page.sync="page"
                        :footer-props="{
                            'items-per-page-options': [10, 25, 50, 100]
                        }"
                        :items="data">
                        <template v-slot:[`item.freezed`]="{item}">
                            <v-badge dot inline :color="item.freezed ? 'warning' : 'success' "></v-badge>
                                {{item.freezed ? 'Freezed' : 'Enabled'}}
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-sheet>
        <v-dialog v-model="dialog" max-width="400">
            <v-card>
                <v-card-title>Search GL Account</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-text-field
                                label="Number"
                                outlined
                                v-model="search.number"
                                dense
                                hide-details="auto"
                                @keypress.enter="handleSearch"
                                clearable
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                label="Name"
                                outlined
                                v-model="search.name"
                                dense
                                hide-details="auto"
                                @keypress.enter="handleSearch"
                                clearable
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                label="Currency"
                                v-model="search.currency_id"
                                outlined
                                dense
                                hide-details="auto"
                                @keypress.enter="handleSearch"
                                clearable
                                :items="currencies"
                                item-text="name"
                                item-value="id"
                                ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                label="Type"
                                outlined
                                v-model="search.type_id"
                                dense
                                hide-details="auto"
                                :items="accountTypes"
                                item-text="name"
                                item-value="id"
                                @keypress.enter="handleSearch"
                                clearable
                                ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                label="Enabled"
                                outlined
                                v-model="search.freezed"
                                dense
                                :items="freezeSelectItems"
                                hide-details="auto"
                                @keypress.enter="handleSearch"
                                clearable
                                ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn block color="primary" @click="handleSearch">
                        <v-icon left>mdi-magnify</v-icon>
                        search
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { getAccountsList, freezeAccount, unfreezeAccount } from './../../services/ledger/account';
import { mapState, mapActions } from 'vuex';
export default {
    data() {
        return {
            headers: [
                { text: "Number", value: "number" },
                { text: "Name", value: "name" },
                { text: "Currency", value: "currency" },
                { text: "Type", value: "type" },
                { text: "Enabled", value: "freezed" }
            ],
            data: [],
            loading: false,
            actionsLoading: false,
            options: {},
            count: 0,
            dialog: false,
            search: {
                number: "",
                name: "",
                currency_id: null,
                type_id: null,
                freezed: null
            },
            page: 1,
            freezeSelectItems: [
                { text: "Enabled", value: "0" },
                { text: "Freezed", value: "1" },
                { text: "All", value: null },
            ],
            selected: []
        }
    },
    computed: {
        ...mapState('accounting/currency', ["currencies"]),
        ...mapState('accounting/accountType', ["accountTypes"]),
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetchAccountsList();
            }
        }
    },
    methods: {
        ...mapActions('accounting/currency', ['fetchCurrencies']),
        ...mapActions('accounting/accountType', ['fetchAccountTypes']),
        ...mapActions({
            snackbar: "ui/snackbar/show"
        }),
        fetchAccountsList() {
            this.selected = [];
            this.loading = true;
            getAccountsList({...this.options, ...this.search}).then(response => {
                this.data = response.data.data;
                this.count = response.data.count;
            }).finally(() => this.loading = false)
        },
        handleSearch() {
            this.fetchAccountsList();
            this.page = 1;
            this.dialog = false;
        },
        handleFreezeAccount() {
            this.loading = true;
            freezeAccount(this.selected.map(each => each.id)).then(response => {
                this.snackbar({ text: response.data.message, color: "success"});
                this.fetchAccountsList();
            })
            .catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            })
            .finally(() => this.loading = false);
        },
        handleUnfreezeAccount() {
            this.loading = true;
            unfreezeAccount(this.selected.map(each => each.id)).then(response => {
                this.snackbar({ text: response.data.message, color: "success"});
                this.fetchAccountsList();
            })
            .catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            })
            .finally(() => this.loading = false);
        }
    },
    created() {
        this.fetchCurrencies();
        this.fetchAccountTypes();
    },
    destroyed() {
        
    }
}
</script>

<style>

</style>